import { IFaqArticle, IFaqArticleDto, IFaqArticleSearchTag, IFaqCategory, IGetArticleSearchTagsParams } from './faq.types'
import http, { handleHttpError, handleHttpResponse } from '../../../services/http'
import { HTTPResponse, IPaginationResponse } from 'services/http/http.types'
import httpUtils from '../../../services/http/http.utils'

const categoriesList = (): Promise<HTTPResponse<IFaqCategory[]>> => {
  return http.get('/nsi/v1/knowledge-base/categories/list/all').then(handleHttpResponse).catch(handleHttpError)
}

const createCategory = (
  dto: Pick<IFaqCategory, 'parentId' | 'title' | 'ordering'>
): Promise<HTTPResponse<IFaqCategory>> => {
  return http.post('/nsi/v1/knowledge-base/categories', dto).then(handleHttpResponse).catch(handleHttpError)
}

const updateCategory = (
  id: IFaqCategory['id'],
  dto: Partial<Pick<IFaqCategory, 'parentId' | 'title' | 'ordering'>>
): Promise<HTTPResponse<IFaqCategory>> => {
  return http
    .patch('/nsi/v1/knowledge-base/categories/' + id, dto)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const deleteCategory = (id: IFaqCategory['id']): Promise<HTTPResponse<IFaqCategory>> => {
  return http
    .delete('/nsi/v1/knowledge-base/categories/' + id)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const articlesList = (): Promise<HTTPResponse<IFaqArticle[]>> => {
  return http.get('/nsi/v1/knowledge-base/articles/list/all').then(handleHttpResponse).catch(handleHttpError)
}

const createArticle = (
  dto: IFaqArticleDto
): Promise<HTTPResponse<IFaqArticle>> => {
  return http.post('/nsi/v1/knowledge-base/articles', dto).then(handleHttpResponse).catch(handleHttpError)
}

const updateArticle = (
  id: IFaqArticle['id'],
  dto: IFaqArticleDto
): Promise<HTTPResponse<IFaqArticle>> => {
  return http
    .patch('/nsi/v1/knowledge-base/articles/' + id, dto)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const deleteArticle = (id: IFaqArticle['id']): Promise<HTTPResponse<IFaqArticle>> => {
  return http
    .delete('/nsi/v1/knowledge-base/articles/' + id)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const getArticleSearchTags = httpUtils.createAbortableRequest(
  (signal, params: IGetArticleSearchTagsParams): Promise<HTTPResponse<IPaginationResponse<IFaqArticleSearchTag>>> => {
    return http
      .get('/nsi/v1/knowledge-base/search-tags', { signal, params })
      .then((resp) => {
        if (resp && resp.data) {
          return handleHttpResponse({ ...resp, data: { ...resp.data, results: resp.data.items } })
        }
        return { status: 'error', message: '' } as any
      })
      .catch(handleHttpError)
  }
)

const getArticleSearchTag = (id: IFaqArticleSearchTag['id']): Promise<HTTPResponse<IFaqArticleSearchTag>> => {
  return http
    .get('/nsi/v1/knowledge-base/search-tags/' + id)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const createArticleSearchTag = (
  dto: Pick<IFaqArticleSearchTag, 'name'>
): Promise<HTTPResponse<IFaqArticleSearchTag>> => {
  return http.post('/nsi/v1/knowledge-base/search-tags', dto).then(handleHttpResponse).catch(handleHttpError)
}

const updateArticleSearchTag = (
  id: IFaqArticleSearchTag['id'],
  dto: Pick<IFaqArticleSearchTag, 'name'>
): Promise<HTTPResponse<IFaqArticleSearchTag>> => {
  return http
    .patch('/nsi/v1/knowledge-base/search-tags/' + id, dto)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const deleteArticleSearchTags = (ids: IFaqArticleSearchTag['id'][]): Promise<HTTPResponse<IFaqArticleSearchTag[]>> => {
  return http
    .delete('/nsi/v1/knowledge-base/search-tags', { params: { ids: ids.join(',') } })
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const searchArticles = (search: string): Promise<HTTPResponse<IFaqArticle[]>> => {
  return http
    .get('/nsi/v1/knowledge-base/search', { params: { search } })
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const faqApi = {
  categoriesList,
  articlesList,
  createCategory,
  updateCategory,
  deleteCategory,
  createArticle,
  updateArticle,
  deleteArticle,
  getArticleSearchTags,
  getArticleSearchTag,
  createArticleSearchTag,
  updateArticleSearchTag,
  deleteArticleSearchTags,
  searchArticles,
}
export default faqApi
